NOT_RELATIVE_REGEX